<section
  class="widget-display-products"
  [style.background]="widget?.bg_color || null"
>
  <div class="widget-display-products__inner">
    <ng-container *ngIf="title">
      <h2 class="widget-display-products__title">{{ title }}</h2>
    </ng-container>

    <div
      class="widget-display-products__grid"
      *ngIf="!isSlider"
      [style.--dp-cols]="columns"
    >
      <ng-container *ngIf="products.length; else emptyState">
        <ade-classified-card *ngFor="let v of products" [item]="v">
        </ade-classified-card>
      </ng-container>
    </div>

    <div
      class="widget-display-products__slider-wrap"
      *ngIf="isSlider && products.length"
    >
      <button
        type="button"
        class="widget-display-products__nav widget-display-products__nav--prev"
        [attr.aria-label]="'Anterior' | transloco"
        (click)="slidePrev()"
      >
        <mat-icon [svgIcon]="'heroicons_outline:chevron-left'"></mat-icon>
      </button>

      <swiper-container
        #swiper
        txSwiper
        [config]="swiperConfig"
        init="false"
        class="widget-display-products__slider"
      >
        <swiper-slide *ngFor="let v of products">
          <ade-classified-card [item]="v"></ade-classified-card>
        </swiper-slide>
      </swiper-container>

      <button
        type="button"
        class="widget-display-products__nav widget-display-products__nav--next"
        [attr.aria-label]="'Seguinte' | transloco"
        (click)="slideNext()"
      >
        <mat-icon [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
      </button>
    </div>

    <ng-template #emptyState>
      <p class="widget-display-products__empty">
        {{ "Sem produtos nesta secção." | transloco }}
      </p>
    </ng-template>
    <ng-container
      *ngIf="isSlider && !products.length"
      [ngTemplateOutlet]="emptyState"
    ></ng-container>

    <footer
      class="widget-display-products__footer"
      *ngIf="widget?.btn_sell_all_name"
    >
      <a
        [routerLink]="widget?.btn_sell_all_link"
        class="widget-display-products__footer--link px-8 py-3 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl uppercase tracking-wider text-sm"
      >
        {{ widget?.btn_sell_all_name }}
      </a>
    </footer>
  </div>
</section>
